import React from "react"
import {Checkbox, Col, Row, Tooltip} from "antd"
import {QuestionCircleOutlined} from "@ant-design/icons"
import {useTranslation} from "react-i18next"
import {FormLabel} from "components/Form"
import {getFullName} from "helpers"
import {SmsPhoneNumberDialerDetailResponse, SmsPhoneNumberDialerSettings} from "types/sms-dialer-settings"
import styles from "./PhoneNumberDetails.module.css"

type Props = {
    phone: SmsPhoneNumberDialerDetailResponse["phone"]
    settings: SmsPhoneNumberDialerSettings
    onChange: React.Dispatch<React.SetStateAction<SmsPhoneNumberDialerSettings>>
    canEdit: boolean
}

const SmsPhoneNumberGeneralInfo: React.FC<Props> = ({phone, settings, onChange, canEdit}) => {
    const {t} = useTranslation(["settings"])

    const campuses = (phone.campuses ?? []).map((c) => c.name).join(", ") || t("smsSettings.dialerSettings.noValue")
    const departments =
        (phone.departments ?? []).map((d) => d.name).join(", ") || t("smsSettings.dialerSettings.noValue")
    const userName = phone.user ? getFullName(phone.user) : t("smsSettings.dialerSettings.noValue")
    const dialerDept = phone.departmentForDialer?.name || t("smsSettings.dialerSettings.noValue")

    return (
        <div>
            <h3 className={styles.subtitle}>{t("smsSettings.dialerSettings.generalInfo")}</h3>
            <Row gutter={[40, 24]}>
                <Col span={12}>
                    <FormLabel label={t("smsSettings.dialerSettings.user")} />
                    <div className={styles.readonlyField}>{userName}</div>
                </Col>
                <Col span={12}>
                    <FormLabel label={t("smsSettings.dialerSettings.campus")} />
                    <div className={styles.readonlyField}>{campuses}</div>
                </Col>
                <Col span={12}>
                    <FormLabel label={t("smsSettings.dialerSettings.department")} />
                    <div className={styles.readonlyField}>{departments}</div>
                </Col>
                <Col span={12}>
                    <FormLabel label={t("smsSettings.dialerSettings.departmentForDialer")} />
                    <div className={styles.readonlyField}>{dialerDept}</div>
                </Col>
                <Col span={24}>
                    <Checkbox
                        checked={Boolean(settings.prioritizeRecentStaff)}
                        disabled={!canEdit}
                        onChange={(event) =>
                            onChange((prev) => ({
                                ...prev,
                                prioritizeRecentStaff: event.target.checked
                            }))
                        }>
                        <span className={styles.checkboxLabelWithTooltip}>
                            {t("smsSettings.dialerSettings.prioritizeRecentStaff")}
                            <Tooltip title={t("smsSettings.dialerSettings.prioritizeRecentStaffDescription")}>
                                <QuestionCircleOutlined className={styles.checkboxHelpIcon} />
                            </Tooltip>
                        </span>
                    </Checkbox>
                </Col>
            </Row>
        </div>
    )
}

export default SmsPhoneNumberGeneralInfo
